import { IonLoading } from "@ionic/react";
import { Button, Col } from "antd";
import { useState } from "react";
import "../index.css";

const Submit = (props) => {
  const [showLoading, setShowLoading] = useState(false);

  const isDisabled = props.colors.length < 1 || props.isLoading || props.previewLoading || props.disabled;

  const handleSubmit = async () => {
    setShowLoading(true);
    props.setIsLoading(true);
    try {
      await props.saveToCloud(true);
    } catch (error) {
      console.error("Error processing image:", error);
    } finally {
      setShowLoading(false);
      props.setIsLoading(false);
    }
  };

  return (
    <Col>
      <IonLoading
        isOpen={showLoading}
        message={"Saving..."}
        id="custom-loading"
      />
      <Button
        disabled={isDisabled}
        onClick={handleSubmit}
        style={{
          background: isDisabled ? "rgba(200,200,200,0.7)" : "linear-gradient(135deg, #e83e8c 0%, #d63384 100%)",
          borderRadius: "12px",
          padding: "0 24px",
          height: "44px",
          color: isDisabled ? "#999" : "white",
          fontSize: "15px",
          fontWeight: 600,
          fontFamily: "Clash Grotesk",
          display: "flex",
          alignItems: "center",
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.6 : 1,
          border: "none",
          boxShadow: isDisabled ? "none" : "0 0 10px rgba(232, 62, 140, 0.45), 0 0 24px rgba(232, 62, 140, 0.25)",
          animation: isDisabled ? "none" : "submitGlow 2s ease-in-out infinite",
          transition: "all 0.2s ease",
        }}
        data-action="download"
        data-onboarding-target="download"
        data-tutorial={props["data-tutorial"]}
      >
        {props.children}
      </Button>
    </Col>
  );
};

export default Submit;
